import campaignSliceReducer from './slice';

export const campaignReducer = campaignSliceReducer;
